(function(){
var root=document.querySelector('.drift-pdp');if(!root)return;
var data=JSON.parse(document.getElementById('drift-data').textContent);
var COLORS=[
{id:'ocean-blue',name:'Ocean Blue',cord:'Slate blue long cord, sky blue short cord',c:'#2447C4',g:'trail'},
{id:'honey',name:'Honey',cord:'Slate blue long cord, sky blue short cord',c:'#F6CE5E',g:'trail'},
{id:'pine',name:'Pine',cord:'Khaki long cord, spring green short cord',c:'#3F5A32',g:'trail'},
{id:'moonlight',name:'Moonlight',cord:'Sage long cord, sky blue short cord',c:'#F6EFC8',g:'trail'},
{id:'lake',name:'Lake',cord:'Sage long cord, spring green short cord',c:'#C6DDBC',g:'trail'},
{id:'berry',name:'Berry',cord:'Aqua long cord, sky blue short cord',c:'#F47F72',g:'treat'},
{id:'pistachio',name:'Pistachio',cord:'Aqua long cord, pink short cord',c:'#BFDC8C',g:'treat'},
{id:'peach',name:'Peach',cord:'Lemon long cord, mint short cord',c:'#F9D9C8',g:'treat'},
{id:'taro',name:'Taro',cord:'Lemon long cord, sky blue short cord',c:'#EBD8EE',g:'treat'},
{id:'ice',name:'Ice',cord:'Blush long cord, pink short cord',c:'#A9E0E6',g:'treat'}
];
var HOURS=[
{t:'6 a.m.',id:'moonlight',line:'First light, moka pot on the stove.',drink:'Moka coffee',d:'#3b2416',lvl:.72,tint:'#F8F4DC'},
{t:'7 a.m.',id:'ocean-blue',line:'Dock, thermos, the water still flat.',drink:'Black coffee',d:'#2a170d',lvl:.7,tint:'#D9E0F5'},
{t:'8 a.m.',id:'peach',line:'The shot you pulled yourself, before anyone is up.',drink:'Espresso',d:'#2a170d',lvl:.5,tint:'#FCEEE6'},
{t:'9 a.m.',id:'honey',line:'Out the door. It rides on your bag.',drink:'Empty, for now',d:'#2a170d',lvl:0,tint:'#FCF0CC'},
{t:'11 a.m.',id:'pistachio',line:'A late-morning matcha, cup around your neck.',drink:'Matcha',d:'#7f9c3a',lvl:.62,tint:'#EEF5DE'},
{t:'1 p.m.',id:'lake',line:'A corner table and an espresso after lunch.',drink:'Espresso',d:'#2a170d',lvl:.5,tint:'#E8F1E3'},
{t:'3 p.m.',id:'ice',line:'Stoop, cold brew, nowhere to be.',drink:'Cold brew',d:'#2c1a10',lvl:.8,tint:'#E0F4F6'},
{t:'5 p.m.',id:'berry',line:'Saturday market, one more pour from the cart.',drink:'Cart coffee',d:'#3b2416',lvl:.66,tint:'#FDE4E0'},
{t:'7 p.m.',id:'pine',line:'One last espresso before the lights go down.',drink:'Espresso',d:'#2a170d',lvl:.5,tint:'#E0E6DC'},
{t:'10 p.m.',id:'taro',line:'Records on. A small decaf to end the night.',drink:'Decaf',d:'#4a2e1c',lvl:.58,tint:'#F2E8F4'}
];
function media(key){for(var i=0;i<data.media.length;i++){if(data.media[i].src.indexOf(key)>-1)return data.media[i]}return{src:'',alt:''}}
function variantFor(c){for(var i=0;i<data.variants.length;i++){if(data.variants[i].title===c.name)return data.variants[i]}return null}
function colorById(id){return COLORS.filter(function(x){return x.id===id})[0]}
function $(id){return document.getElementById(id)}
var stage=$('stage'),thumbs=$('thumbs'),nameEl=$('colorName'),idInput=$('driftVariant'),atc=$('atc');
var active=COLORS[0];
for(var v=0;v<COLORS.length;v++){var vr=variantFor(COLORS[v]);if(vr&&vr.id===data.selected){active=COLORS[v];break}}
function drawThumbs(){
  thumbs.innerHTML='';
  var list=[media('hero-'+active.id),media('scene-'+active.id),media('size-can'),media('scale-hand'),media('both-cords'),media('family-'+active.g)];
  list.forEach(function(s,i){
    var b=document.createElement('button');b.type='button';b.setAttribute('aria-label',s.alt);
    if(i===0)b.setAttribute('aria-current','true');
    var im=document.createElement('img');im.src=s.src;im.alt='';im.width=200;im.height=200;b.appendChild(im);
    b.addEventListener('click',function(){stage.src=s.src;stage.alt=s.alt;
      thumbs.querySelectorAll('button').forEach(function(x){x.removeAttribute('aria-current')});b.setAttribute('aria-current','true')});
    thumbs.appendChild(b);
  });
}
function pick(c,scroll){
  active=c;var h=media('hero-'+c.id);stage.src=h.src;stage.alt=h.alt;nameEl.textContent=c.name;
  root.querySelectorAll('.sw').forEach(function(s){s.setAttribute('aria-checked',s.dataset.id===c.id?'true':'false')});
  drawThumbs();
  var vr=variantFor(c);
  if(vr){idInput.value=vr.id;atc.disabled=!vr.available;atc.textContent=vr.available?'Add to cart':'Sold out';
    try{var u=new URL(location.href);u.searchParams.set('variant',vr.id);history.replaceState(null,'',u)}catch(e){}}
  if(scroll)stage.scrollIntoView({behavior:'smooth',block:'center'});
}
COLORS.forEach(function(c){
  var s=document.createElement('button');s.type='button';s.className='sw';s.dataset.id=c.id;s.setAttribute('role','radio');s.setAttribute('aria-label',c.name);s.title=c.name;
  s.style.setProperty('--c',c.c);s.addEventListener('click',function(){pick(c)});
  $(c.g).appendChild(s);
  var h=media('hero-'+c.id),t=document.createElement('button');t.type='button';t.className='tile';
  t.innerHTML='<div class="ph"><img loading="lazy" src="'+h.src+'" alt="" width="600" height="600"></div><div><b>'+c.name+'</b><span>'+c.cord+'</span></div>';
  t.addEventListener('click',function(){pick(c,true)});
  $('range').appendChild(t);
});
pick(active);
var hoursEl=$('hours'),photo=$('hoursPhoto'),dial=$('hoursDial'),ticks=$('hoursTicks'),hoursNow=0;
$('hoursTrack').style.background='linear-gradient(90deg,'+HOURS.map(function(h,i){
  var hex=colorById(h.id).c,step=100/HOURS.length;
  return hex+' '+(i*step+step*.2)+'%,'+hex+' '+(i*step+step*.8)+'%';
}).join(',')+')';
HOURS.forEach(function(h,i){
  var m=media('scene-'+h.id),c=colorById(h.id);
  var im=document.createElement('img');im.src=m.src;im.alt=m.alt;im.width=1000;im.height=1000;if(i>0)im.loading='lazy';photo.appendChild(im);
  var b=document.createElement('button');b.type='button';b.textContent=h.t.replace(/\.| /g,'');b.setAttribute('aria-label',h.t+', '+c.name);
  b.addEventListener('click',function(){setHour(i)});ticks.appendChild(b);
});
function setHour(i){
  hoursNow=i;var h=HOURS[i],c=colorById(h.id);
  dial.value=i;
  hoursEl.style.setProperty('--tint',h.tint);dial.style.setProperty('--thumb',c.c);
  $('hoursTime').textContent=h.t;$('hoursColor').textContent=c.name;$('hoursLine').textContent=h.line;$('hoursDrink').textContent=h.drink;$('hoursCta').textContent='Choose '+c.name;
  [].forEach.call(photo.children,function(el,k){el.classList.toggle('on',k===i)});
  [].forEach.call(ticks.children,function(el,k){if(k===i)el.setAttribute('aria-current','true');else el.removeAttribute('aria-current')});
  var body=$('cupBody'),handle=$('cupHandle'),liq=$('cupLiquid');
  body.setAttribute('fill',c.c);handle.setAttribute('stroke',c.c);
  var bottom=100,height=(bottom-16)*h.lvl;
  liq.setAttribute('fill',h.d);liq.setAttribute('y',bottom-height);liq.setAttribute('height',height);
}
dial.addEventListener('input',function(){setHour(+dial.value)});
$('hoursCta').addEventListener('click',function(){pick(colorById(HOURS[hoursNow].id),true)});
setHour(0);
var q=$('qty');
$('minus').addEventListener('click',function(){q.value=Math.max(1,(+q.value||1)-1)});
$('plus').addEventListener('click',function(){q.value=Math.min(99,(+q.value||1)+1)});
var copy=$('copyCode');
if(copy)copy.addEventListener('click',function(){
  try{navigator.clipboard.writeText('DRIFT10').then(function(){copy.textContent='Copied'},function(){copy.textContent='Copy failed'})}catch(x){copy.textContent='Copy failed'}
});
})();
